export default __webpack_public_path__ + "40309e0c7ce30c11446556730508b441.png";